module.exports = __webpack_public_path__ + "static/media/1 05 gjerde.def36a0c.mp3";